function importAllIcons (filterBy = '') {
  const req = require.context('@/assets/images/icons', false, /\.(png)$/)

  let filteredIcons = req.keys()

  if (filterBy === 'original') {
    filteredIcons = req.keys().filter(item => !item.match('outlined'))
  } else if (filterBy === 'outlined') {
    filteredIcons = req.keys().filter(item => item.match('outlined'))
  }

  return filteredIcons.map(item => item.replace('.png', '').replace('./', ''))
}

function importBookIcons () {
  const req = require.context('@/assets/images/book-icons', false, /\.(svg)$/)

  const icons = req.keys()

  return icons.map(item => item.replace('.svg', '').replace('./', ''))
}

function randomBookIcon () {
  const icons = importBookIcons()
  const lastColorIndex = icons.length - 1

  const index = Math.floor(Math.random() * lastColorIndex)

  return icons[index]
}

export default {
  original: importAllIcons('original'),
  outlined: importAllIcons('outlined'),
  bookIcons: importBookIcons(),
  icons: importAllIcons(),
  getBookIcon: randomBookIcon
}
